import styled from 'styled-components';

import { Text } from '../../../../components';
import { OWN_LIST } from '@/nova/theme/tokens';

/* A tag under the header's title, saying what it names: one of the brand's own (Game Lists' "User list"), in the lilac
   the brand's own lists wear. */
export const HeaderTag = styled(Text)`
  display: inline-flex;
  align-items: center;
  height: 16px;
  padding: 0 8px;
  border: 1px solid ${OWN_LIST.border};
  border-radius: 999px;
  font-size: 11px;
  font-weight: 600;
  line-height: 1;
  color: ${OWN_LIST.mark};
`;
